import { computed, toValue } from "vue";
const useAlignment = (align) => computed(() => {
  const value = toValue(align);
  return !value ? "" : `justify-content-${value}`;
});
export {
  useAlignment as u
};
//# sourceMappingURL=useAlignment-Cw-9AVid.mjs.map
